import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type BoltIconProps = IconProps;

const BoltIcon: FC<BoltIconProps> = ({ className, iconColor = '#344054', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 24 24"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 2L4.09347 12.6879C3.74466 13.1064 3.57026 13.3157 3.56761 13.4925C3.56531 13.6461 3.63425 13.7923 3.75491 13.8875C3.89384 13.9972 4.16613 13.9972 4.71069 13.9972H11L10 22L18.9065 11.3121C19.2553 10.8936 19.4297 10.6843 19.4324 10.5075C19.4347 10.3539 19.3657 10.2077 19.2451 10.1125C19.1061 10.0028 18.8338 10.0028 18.2893 10.0028H12L13 2Z"
      fill={iconColor}
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

BoltIcon.displayName = 'BoltIcon';

export default BoltIcon;
